module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/why-pict-15476ac89238bd4d65a6993c201fc28a.jpg";